import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { langDashCodesDictionary } from "../../../../constants";

const Table = ({ data }) => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;

	return (
		<Box
			sx={{
				display: "flex",
				width: "100%",
				justifyContent: "space-between",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					rowGap: "10px",
					flex: "1 1 160px",
					"& > div": {
						padding: "10px 20px",
						flex: "1 1 20%",
					},
				}}
			>
				<Box></Box>
				<Box sx={{ background: "#f5f5f5" }}>{t("entered_1")}</Box>
				<Box sx={{ background: "#f5f5f5", color: "#AE78D6" }}>
					{t("sold_label")}
				</Box>
				<Box sx={{ background: "#f5f5f5", color: "#A6A6A6" }}>
					{t("unsold_label")}
				</Box>
				<Box sx={{ background: "#f5f5f5", color: "#00B050" }}>
					{t("margin_label")} (€)
				</Box>
			</Box>

			{data.map((values, index) => {
				const parsedDate = new Date();
				parsedDate.setMonth(values.month - 1);

				return (
					<Box
						key={`sa-stats-table-row-${index}`}
						sx={{
							display: "flex",
							flexDirection: "column",
							rowGap: "10px",
							flex: "1 1 calc((100% - 160px)/13)",
							"& > div": {
								flex: "1 1 20%",
								padding: "10px 0",
								textAlign: "center",
							},
						}}
					>
						<Box>
							{parsedDate.toLocaleString(
								langDashCodesDictionary[lang] || "pl-PL",
								{
									month: "short",
								}
							)}
						</Box>
						<Box sx={{ background: "#f5f5f5" }}>{values.entered}</Box>
						<Box sx={{ background: "#f5f5f5", color: "#AE78D6" }}>
							{values.sold}
						</Box>
						<Box sx={{ background: "#f5f5f5", color: "#A6A6A6" }}>
							{values.notSold}
						</Box>
						<Box sx={{ background: "#f5f5f5", color: "#00B050" }}>
							{values.margin}
						</Box>
					</Box>
				);
			})}
		</Box>
	);
};

export default Table;
